import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../services/authentication.service';
import { HeaderTemplateData } from '../dialog-data.interface';


@Component({
  selector: 'payment-confirm-dialog',
  templateUrl: './payment-confirm-dialog.html',
  styleUrls: ['./payment-confirm-dialog.scss']
})
export class PaymentConfirmDialog implements OnInit {

  form: FormGroup;

  currencySymbol: string;
  header: HeaderTemplateData;
  constructor(
    public dialogRef: MatDialogRef<PaymentConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,
    private _snackBar: MatSnackBar,
    private _fb: FormBuilder,
    private _authService: AuthenticationService

  ) {
    if (data) {
      this.header = data;
    }
  }

  ngOnInit() {
    this.form = this._fb.group({
      amount: ['', Validators.required]
    });
    this.form.get('amount').setValue(Number(this.header.title.rightTopTitle.text));
    this.currencySymbol = this._authService.userInfo.account.settings.currencySymbol;
  }

  makePayment() {
    const value = this.form.controls['amount'].value;
    if (this.form.valid || value != 0) {
      this.dialogRef.close(value);
    } else {
      this._snackBar.open('Please enter a valid amount', 'Dismiss', {
        duration: 3500
      });
    }
  }

}
